import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { CostCenterListItemModel } from '../../models/cost-center/cost-center-list-item.model';
import { CostCenterListParams } from '../../models/client-models';

const COST_CENTER_ENDPOINT = 'costcenter';

@Injectable({
  providedIn: 'root',
})
export class CostCenterBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get cost center list form backend with paging and filter.
   *
   * @param costCenterParams filter and paging and personID
   */
  public getCostCenterList(costCenterParams: CostCenterListParams) {
    return this.http.post<CostCenterListItemModel[]>(
      AppConfig.settings.backend.url + COST_CENTER_ENDPOINT,
      costCenterParams
    );
  }

  /**
   * Get cost center by id.
   *
   * @param costCenterID id of cost center.
   */
  public getCostCenterByID(costCenterID: number) {
    return this.http.get<CostCenterListItemModel>(
      AppConfig.settings.backend.url +
        COST_CENTER_ENDPOINT +
        '?costCenterID=' +
        costCenterID
    );
  }
}
